
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import { usePersonalStore } from '../../../stores/personalInfo'
import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const MsInformationOnline = ({ navigation, route }: any) => {

    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        blind_and_age_total,
        age65,
        blind,
        total
    } = params
    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postmsonline } = useFormsStore()
    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey:
                intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey:
                essUserOnBoardingFormKey,
            completeOnline: true,
            maritalStatus: values?.martialstatus,
            spouseEmployed: values?.spouseemployed,
            SpouseClaimedAmount: values?.spouseamount,
            ageAndBlindnessAmount: blind_and_age_total,
            totalAmount: total,
            additionalWithholding: values?.additionalamount ? values?.additionalamount : null,
            serviceMemberReliefExempt: (values?.exempt || "").toUpperCase(),
            sign: signatureDataURL,
            ageHusband: age65.includes('1') ? 1 : 0,
            ageWife: age65.includes('2') ? 1 : 0,
            ageSingle: age65.includes('3') ? 1 : 0,
            blindnessHusband: blind.includes('1') ? 1 : 0,
            blindnessWife: blind.includes('2') ? 1 : 0,
            blindnessSingle: blind.includes('3') ? 1 : 0,
            Dependents: values?.dependents ? Number(values?.dependents) : null

        }

        const response: any = await postmsonline(data)

        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MS Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('MsInformationform', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}

export default MsInformationOnline
